import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { ProfileData, ProfileParm } from "src/popup/types/types";
import { BasicProfile } from "protico-sdk";
import { TypedThunk } from "..";
import i18n from "../../public/locales/i18n";
import { TaskStateType } from "../../types/types";
import { getProticoClient } from "../../utils/api";
import { uploadFile, getImageAssetUrl } from "../../utils/ipfs.utils";

type ProfileSate = {
  userBlockList: Array<string>;
  isImgFetching: boolean;
  isUserProfileFetching: boolean;
};

const initialState: ProfileSate = {
  userBlockList: [],
  isImgFetching: false,
  isUserProfileFetching: false,
};

enum acceptFileType {
  "image/png",
  "image/jpg",
  "image/jpeg",
}

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setIsImgFetching: (state, action: PayloadAction<boolean>) => {
      state.isImgFetching = action.payload;
    },

    setIsUserProfileFetching: (state, action: PayloadAction<boolean>) => {
      state.isUserProfileFetching = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIsImgFetching, setIsUserProfileFetching } =
  profileSlice.actions;

export default profileSlice.reducer;
export const saveProfilePicture =
  (
    image: File,
    handleSetAlert: any,
    refetch: any,
    realAddress: string
  ): TypedThunk =>
  async (dispatch) => {
    //check file size
    if (image?.size > 1048576) {
      handleSetAlert(
        i18n.t("Alert_Content_Image_Size_Too_Large"),
        TaskStateType.FAIL
      );
      return;
    }
    if (!isPropertyValue(acceptFileType, image.type)) {
      handleSetAlert(
        i18n.t("Alert_Content_Incorrect_File_Type"),
        TaskStateType.FAIL
      );
      return;
    }
    dispatch(setIsImgFetching(true));
    var src;
    try {
      src = await uploadFile(image);
      if (!src) {
        handleSetAlert(
          i18n.t("Alert_Content_General_Image_Error"),
          TaskStateType.FAIL
        );
        return;
      }
    } catch (e) {
      handleSetAlert(e, TaskStateType.FAIL);
      return;
    }
    // const srcURL = getInfuraUrl(src);
    const srcURL = getImageAssetUrl(realAddress + "/" + image.name);
    const img = {
      avatar_url: srcURL,
    };
    await updateProfileAndCheck(img, refetch, handleSetAlert);
    dispatch(setIsImgFetching(false));
  };
export const saveProfilePictureFromUrl =
  (srcURL: string, handleSetAlert: any, refetch: any): TypedThunk =>
  async (dispatch) => {
    dispatch(setIsImgFetching(true));
    const newProfile = {
      avatar_url: srcURL,
    };
    await updateProfileAndCheck(newProfile, refetch, handleSetAlert);
    dispatch(setIsImgFetching(false));
  };
export const saveUserProfileInfo =
  (userProfile: BasicProfile, refetch: any, handleSetAlert?: any): TypedThunk =>
  async (dispatch) => {
    dispatch(setIsUserProfileFetching(true));
    await updateProfileAndCheck(userProfile, refetch, handleSetAlert);
    dispatch(setIsUserProfileFetching(false));
  };
const updateProfileAndCheck = async (
  userProfile: BasicProfile,
  refetch: any,
  handleSetAlert?: any
) => {
  try {
    await getProticoClient().profile.update(userProfile);
    await refetch();
    if (handleSetAlert)
      handleSetAlert(
        i18n.t("Alert_Content_Profile_Update_Success"),
        TaskStateType.SUCCESS
      );
  } catch (e) {
    if (handleSetAlert) handleSetAlert(e.message, TaskStateType.FAIL);
  }
};

function isPropertyValue<T>(
  object: T,
  possibleValue: any
): possibleValue is T[keyof T] {
  return Object.values(object).includes(possibleValue);
}
